import type { ReactNode } from "react";

interface EmptyStateProps {
  icon: string;
  title: string;
  description?: string;
  action?: ReactNode;
}

export default function EmptyState({ icon, title, description, action }: EmptyStateProps) {
  return (
    <div className="flex flex-col items-center rounded-lg border border-dashed border-background-300 bg-background-50 px-6 py-12 text-center">
      <span className="flex h-14 w-14 items-center justify-center rounded-full bg-background-100 text-foreground-500">
        <i className={`${icon} text-2xl leading-none`} aria-hidden="true"></i>
      </span>
      <h3 className="mt-4 text-base font-heading font-semibold text-foreground-900">{title}</h3>
      {description && <p className="mt-1.5 max-w-md text-sm text-foreground-600">{description}</p>}
      {action && <div className="mt-5">{action}</div>}
    </div>
  );
}